module.exports = __webpack_public_path__ + "img/icn_publish_v1.1.59f30685.svg";